import { jsx as _jsx } from "react/jsx-runtime";
export const SvgCross = (props) => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlSpace: 'preserve', viewBox: '0 0 24 24', ...props, children: _jsx("path", { d: 'm8 8 8 8m-8 0 8-8' }) }));
//# sourceMappingURL=cross.js.map